import CampaignType from '../Models/CampaignType';
import DataGridRequest from './DataGridRequest';
export class CampaignsRequest extends DataGridRequest<CampaignType> {
    Url = 'campaigns/api';
}
